import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { IWebMessage } from 'src/app/common/interfaces/webmessage-interface';
import { AbstractCombinedConfigurationService } from '../abstraction/abstract.combined-configuration.service';
import { ICombinedTransactionalSettings } from '../../interfaces/configuration/combined-transactional-settings.interface';

@Injectable({
  providedIn: 'root',
})
export class MockCombinedConfigurationService extends AbstractCombinedConfigurationService {
  private getCombinedTransactionalSettingsJson =
    'assets/mocks/configuration/getCombinedTransactionalSettings.json';

  constructor(private http: HttpClient) {
    super();
  }

  getCombinedTransactionalSettings(
    routingNumber: string
  ): Promise<ICombinedTransactionalSettings | undefined> {
    return lastValueFrom(
      this.http.get<ICombinedTransactionalSettings>(this.getCombinedTransactionalSettingsJson)
    );
  }

  updateCombinedTransactionalSettings(
    settings: ICombinedTransactionalSettings
  ): Promise<IWebMessage | undefined> {
    throw new Error('Method not implemented.');
  }
}
